import { render } from "./EditorLink.vue?vue&type=template&id=27ffede8&scoped=true"
import script from "./EditorLink.vue?vue&type=script&lang=js"
export * from "./EditorLink.vue?vue&type=script&lang=js"

import "./EditorLink.vue?vue&type=style&index=0&id=27ffede8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ffede8"]])

export default __exports__